import React from "react";

const OfferError = ({ message }) => (
  <div className="booking-confirmation enquiry__message enquiry__message--fail callout--flag callout--flag--red">
    <div className="flag">
      <div className="flag__img">
        <i className="fa fa-exclamation-circle fa-fw fa-2x"></i>
      </div>
      <div className="flag__body">{message}</div>
    </div>
  </div>
);

export default OfferError;



// WEBPACK FOOTER //
// ./components/last_minute_deals/OfferError.js